import { render } from "./Contact.vue?vue&type=template&id=ce27b902&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=ce27b902&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kyleb\\OneDrive\\Documenten\\Tess website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce27b902"]])

export default __exports__